<template>
  <div class="wrapper">
    <option-selector
      @on-update="_onUpdate"
      :items="options"
      :shouldSelectSingle="shouldSelectSingle"
      :radioSelect.sync="radioSelect"
    />
    <div class="actions">
      <button :disabled="!isUpdated" @click="_submit">Save</button>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../api-calls";
import OptionSelector from "../../../shared/components/option-selector/option-selector.vue";

export default {
  components: { OptionSelector },
  name: "PatientCommunicationPreferenceManager",
  data: () => ({
    options: [],
    isUpdated: false,
    allOptions: [],
    radioSelect: -1
  }),
  props: {
    type: {
      type: String,
      default: "pd"
    },
    patientId: {
      type: Number,
      default: -1
    },
    shouldSelectSingle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    radioSelect() {
      this.isUpdated = true;
    }
  },
  created() {
    this._load();
  },
  methods: {
    _onUpdate() {
      this.isUpdated = true;
    },
    _getFormattedOptions(allOptions, selections) {
      const idMappedSelections = {};
      selections.forEach(selection => {
        idMappedSelections[selection.CommPerferenceID] = true;
      });
      const formattedOptions = allOptions.map(option => ({
        name: option.messageTypeName,
        id: option.messageTypeID,
        value: idMappedSelections[option.messageTypeID]
      }));
      console.log("formattedOptions", formattedOptions);
      return formattedOptions;
    },
    _generateRadioSelectionValue(selections) {
      this.radioSelect = -1;
      if (selections.length) {
        this.radioSelect = selections[0].CommPerferenceID;
        setTimeout(() => {
          this.isUpdated = false
        }, 200);
      }
    },
    async _load() {
      const { data: allOptions } = await ApiCalls.getAllCommPreferenceTypes();
      let selections = [];
      this.allOptions = allOptions;
      if (this.type === "pd") {
        const { data } = await ApiCalls.getPDCommPreferences(this.patientId);
        selections = data;
      } else {
        const { data } = await ApiCalls.getCommPreferences(this.patientId);
        selections = data;
      }
      if (this.shouldSelectSingle) {
        this._generateRadioSelectionValue(selections);
      }
      this.options = this._getFormattedOptions(allOptions, selections);
    },
    _preparePayload() {
      let ComPerfOrder = [];
      if (this.shouldSelectSingle) {
        console.log("this.radioSelect", this.radioSelect);
        if (this.radioSelect > -1) {
          console.log("this.allOptions", this.allOptions);
          const selectedOption = this.allOptions.find(
            option => option.messageTypeID === this.radioSelect
          );
          if (selectedOption) {
            ComPerfOrder.push({
              CommPerference: selectedOption.messageTypeName,
              CommPerferenceID: selectedOption.messageTypeID
            });
          }
        }
      } else {
        ComPerfOrder = this.options
          .filter(option => option.value)
          .map(option => ({
            CommPerference: option.name,
            CommPerferenceID: option.id
          }));
      }
      return {
        PatientID: this.patientId,
        ComPerfOrder
      };
    },
    async _submit() {
      this.isUpdated = false;
      const payload = this._preparePayload();
      try {
        if (this.type === "pd") {
          ApiCalls.setPDCommPreferences(payload, this.patientId);
        } else {
          ApiCalls.setCommPreferences(payload, this.patientId);
        }
      } catch (error) {
        // a
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  // background: red;
  width: 100%;
  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    button {
      padding: 5px 45px;
      border-radius: 12px;
      background-color: green;
      color: white;
      &:disabled {
        opacity: 0.1;
      }
      &:hover {
        background-color: rgb(2, 90, 2);
      }
    }
  }
}
</style>
